import { useSessionStore } from "../../store/session.store";

const TaskRowInfo = ({ counter, createHandler, templatePlanId, organizationId }) => {
	const { organization } = useSessionStore();
	const taskLink = `${process.env.REACT_APP_HOST_CLIENT_TODO}/plans/${templatePlanId}/tasks${!organization && organizationId ? `?organizations=${organizationId}&scope=all` : ""}`;

	return (
		<div className="flex justify-between items-center min-h-[18px]">
			<div className="flex gap-2 items-center leading-[1em]">
				<span className="icon_16 default task icon_mask !bg-dark-50" />
				<span className="text-dark-50 text-12 font-semibold">Attività</span>
				{!!counter && (
					<a
						href={taskLink}
						target="_blank"
						rel={"noopener noreferrer"}
						className="text-interactive-100 bg-interactive-10 flex gap-2 p-[2px_6px] text-12 rounded-[4px] ml-2 items-center hover:bg-interactive-20"
					>
						Associate <b>{counter}</b>
						<span className="icon_10 default external icon_mask !bg-interactive-100"></span>
					</a>
				)}
			</div>

			<button
				onClick={createHandler}
				type="button"
				className="flex items-center leading-[1em] font-semibold group gap-2 text-12 link-interactive"
			>
				<span className="icon_16 default icon_mask !bg-interactive-100 group-hover:opacity-70 plus" />
				Crea attività
			</button>
		</div>
	);
};

export default TaskRowInfo;
